<template>
  <div class="pheader">
    <div class="section_header" >
      <div class="phone-logo"></div>
     <div class="phone-bar" v-on:click=" off = !off"></div>
    </div>

    <div class="closes" v-bind:class="{push:off}">
        <div class="close" v-on:click="off = !off"><img src="../assets/phone/close.svg" alt=""></div>
        <ul class="nav1">
          <li @click="clickHome()"><div class="menu">
            <div class="write"><a>首页</a></div>
            <div class="icon"></div>
          </div></li>
          <li @click="hardPro()"><div class="menu">
              <div class="write"><a :class="{active:isActive}">硬件产品</a></div>
              <div class="icon" v-show="showone"></div>
              <div class="icon1" v-show="showtwo"></div>
            </div>
          </li>
          <div class="twohard" v-show="showtwo">
            <li @click="clickHardone()"><div class="menu">
              <div class="write"><a>经典维码器</a></div>
              <div class="icon"></div>
              </div>
            </li>
            <li @click="clickHardtwo()"><div class="menu">
              <div class="write"><a>智能投币器</a></div>
              <div class="icon"></div>
              </div>
             </li>
          </div>
          <li @click="clickSoft()"><div class="menu">
              <div class="write"><a>软件服务</a></div>
              <div class="icon"></div>
            </div></li>
          <li @click="clickCase()"><div class="menu">
              <div class="write"><a>合作案例</a></div>
              <div class="icon"></div>
            </div></li>
          <li @click="clickAbout()"><div class="menu">
              <div class="write"><a>关于我们</a></div>
              <div class="icon"></div>
            </div></li>
          <li @click="clickLog()"><div class="menu">
              <div class="write"><a>后台登录</a></div>
              <div class="icon"></div>
            </div></li>
       </ul>
      </div>
  </div>
</template>

<script>
export default {
  name:'pnavbar',
  data(){
      return{
        off:false,
        showone:true,
        showtwo:false,
        isActive:false,
      }
  },
  methods:{
      clickHome:function(){
      this.$router.push({path:'/'});
    },
    clickHardone:function(){
      this.$router.push({path:'/hard/hardone'});
    },
    clickHardtwo:function(){
      this.$router.push({path:'/hard/hardtwo'});
    },
    clickSoft:function(){
      this.$router.push({path:'/software'});
    },
    clickCase:function(){
      this.$router.push({path:'/cooperation'});
    },
    clickAbout:function(){
      this.$router.push({path:'/about'});
    },
    hardPro(){
      this.showone = !this.showone;
      this.showtwo = !this.showtwo;
      this.isActive = !this.isActive;
    }
  }
}
</script>

<style scoped>
@media screen and (max-width:768px){
    .pheader{
    width: 100%;
  z-index: 0;
  position: fixed;
  top: 0;
  left: 0;
}
.pheader .section_header .phone-logo{
  background: url(../assets/phone/logo.svg) no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
}
.section_header{
  background: #000 ;
  width: 100%;
  height: 48px;
  display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    box-sizing: border-box;
    z-index: 2;
}
.pheader .phone-bar{
  display: block;
  background: url(../assets/phone/menu.svg) no-repeat;
  background-size: cover;
  width: 20px;
  height: 20px;
}
.closes{
    display: block;
    width: 100%;
    height: 100vh;
  transition: all 0.15s linear;
    z-index: -1;
   opacity: 0;
   margin-top: -48px;
   background: #000;
   position: relative;
  }
  .closes.push{
  opacity: 1;
  transition: opacity 0.15s linear;
    z-index: 99;
}
  .closes .close{
    width: 100%;
    height: 48px;
    padding: 0px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .close img{
    width: 15px;
	  height: 15px;
  }
  .nav1{
    width:100%;
    display: block;
  }
  .nav1 li{
    display: flex;
    justify-content: center;
  }
  .write a{
    color:#FFF;
    font-size: 13px;
    letter-spacing: 1px;
  }
  .write a.active{
    color: #198bfe;
  }
  .nav1 li .menu{
    width: 80%;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #333;
  }
.nav1 li .menu .icon{
  background: url(../assets/phone/more_right.svg) no-repeat;
  background-size: cover;
  width: 5px;
	height: 9px;
}
.nav1 li .menu .icon1{
  background: url(../assets/phone/more_bottom.svg) no-repeat;
  background-size: cover;
  width: 10px;
  height: 5px;
}
.nav1 .twohard{
  width: 100%;
  height: 90px;
}
}
</style>





// WEBPACK FOOTER //
// src/components/pnavbar.vue